export default __webpack_public_path__ + "media/images/gallery/5-6de13d00bb8e494bbdc829dddddd804a.jpg";